export const FETCH_RATES_INITIATED = 'FETCH_RATES_INITIATED';
export const FETCH_RATES_SUCCEEDED = 'FETCH_RATES_SUCCEEDED';
export const FETCH_RATES_FAILED = 'FETCH_RATES_FAILED';
